<template>
  <Modal
    v-model="_value"
    width="400"
    title="设备主机绑定师傅"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Form v-if="positioningDeviceInfoList.length > 0" ref="loginForm" :model="positioningDeviceInfoList">
      <div v-for="item in positioningDeviceInfoList">
        <FormItem prop="encryptionChipNumber" label="设备芯片码">
          <label style="display: inline-block;">{{item.encryptionChipNumber}}</label>
        </FormItem>
      </div>
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="positioningDeviceInfo.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Form v-else ref="loginForm" :model="positioningDeviceInfo">
      <FormItem prop="name" label="安装员">
        <Select class="field" v-model="positioningDeviceInfo.installerId">
          <Option v-for="item in installers" :value="item.id" :key="item.realName===null?item.name==null?item.nickName:item.name:item.realName">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
        </Select>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'postitioningdeviceinfochangeinstallermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      installers: [],
      positioningDeviceInfo: {
        id: null,
        installerId: null
      },

      positioningDeviceInfoList: [],
      positioningDeviceInfoIds: []
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_ChangeInstaller',
      'UserServ_GetAllUsers',
      'InstallOrderServ_GetDetail'
    ]),
    onOk () {
      if (this.positioningDeviceInfoList != null && this.positioningDeviceInfoList.length > 0) {
        store.dispatch('PositioningDeviceInfoServ_BatchChangeInstaller', {
          params:
            {
              ids: this.positioningDeviceInfoIds,
              installerId: this.positioningDeviceInfo.installerId
            },
          urlparams: null
        }).then(() => {
          this.$Message.success('绑定安装员成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '指派安装员',
          content: '<p>确认绑定安装员</p>',
          onOk: () => {
            store.dispatch('PositioningDeviceInfoServ_ChangeInstaller', {
              params: {
                id: this._initValue,
                installerId: this.positioningDeviceInfo.installerId
              }
            }).then(() => {
              this.$Message.success('绑定安装员成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        console.log(this._listValue)
        this.positioningDeviceInfoList = this._listValue
        if (this.positioningDeviceInfoList != null && this.positioningDeviceInfoList.length > 0) {
          this.positioningDeviceInfoList.forEach(item => {
            this.positioningDeviceInfoIds.push(item.id)
          })
        } else {
          this.positioningDeviceInfoIds = []

          this.positioningDeviceInfo.id = null
          this.positioningDeviceInfo.installerId = null

          let positioningDeviceInfoId = this._initValue
          if (positioningDeviceInfoId) {
            store.dispatch('PositioningDeviceInfoServ_GetDetail', {
              params: { id: positioningDeviceInfoId }
            }).then(() => {
              this.positioningDeviceInfo = store.getters.get_PositioningDeviceInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          let installers = []
          store.getters.get_User_GetAllUsersResult.forEach(item => {
            if (item.state === 1) {
              installers.push(item)
            }
          })
          this.installers = installers
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
